import { render } from "./Product.vue?vue&type=template&id=07dbd10b"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Product.vue?vue&type=style&index=0&id=07dbd10b&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__